<template>
    <v-card rounded="lg" outlined class="applied-card">
        <v-row no-gutters>
            <v-col cols="12" md="auto" class="border-md-end min-w-md-200px min-w-lg-280px">
                <v-layout justify-center align-center class="w-100 h-100 pa-20">
                    <v-img :aspect-ratio="166 / 36" width="166" height="36" max-width="166" contain :src="value?.company?.logo?.url">
                        <v-fade-transition>
                            <v-overlay v-show="!value?.company?.logo?.url" absolute light color="white">
                                <image-overlay>{{ value?.company?.name }}</image-overlay>
                                <!-- <v-layout row align-center class="black--text">
                                    <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                    <span> {{ value?.company?.name }} </span>
                                </v-layout> -->
                            </v-overlay>
                        </v-fade-transition>
                    </v-img>
                </v-layout>
            </v-col>
            <v-col cols="12" md="" class="applied-card__info">
                <div class="pa-20 pa-md-24">
                    <v-row align="center" class="row--large">
                        <v-col cols="12" md="auto" class="applied-card__detail mb-10 mb-md-0">
                            <p class="page-text page-text--sm primary--text mb-4">{{ value?.company?.name }}</p>
                            <h5 class="page-text--lg font-wieght-medium mb-4">
                                {{ value?.title }}
                            </h5>
                            <v-row align="center" class="row--small">
                                <v-col class="applied-card__link">
                                    <p class="page-text grey--text line-height-15">매칭URL: {{ matchUrl }}</p>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn :href="matchUrl" text icon small color="grey"> <v-icon>mdi-link</v-icon> </v-btn>
                                </v-col>
                            </v-row>
                            <meeting-list-item-matching v-bind="{ value }" />
                        </v-col>
                        <v-col cols="12" md="" class="mb-10 mb-md-0">
                            <div class="min-w-120px">
                                <p class="page-text--sm grey-9--text mb-4">상태</p>
                                <v-layout align-center>
                                    <i :class="'mr-4 icon icon-dot icon-dot--' + stateColor" />
                                    <h5 class="page-text--lg font-weight regular">
                                        {{ stateText }}
                                    </h5>
                                </v-layout>
                                <v-fade-transition>
                                    <v-overlay v-show="loading" absolute light color="white">
                                        <v-progress-circular size="40" width="2" indeterminate color="primary" />
                                    </v-overlay>
                                </v-fade-transition>
                            </div>
                        </v-col>
                        <v-col cols="12" md="auto">
                            <v-layout column align-end>
                                <meeting-view v-bind="{ value }" @input="(value) => $emit('input', value)">
                                    <template #activator="{ attrs, on }">
                                        <v-btn v-bind="attrs" v-on="on" small outlined color="primary" class="w-100 mw-lg-100px mb-8"> 미팅일정 선택 </v-btn>
                                    </template>
                                </meeting-view>
                                <v-fade-transition leave-absolute>
                                    <v-btn v-show="!showsScheduleDate" small outlined color="primary" class="w-100 mw-lg-100px" @click="showsScheduleDate = true">미팅 일정 확인</v-btn>
                                </v-fade-transition>
                                <v-fade-transition hide-on-leave>
                                    <v-btn v-show="showsScheduleDate" small color="grey-ec" @click="showsScheduleDate = false">
                                        <span class="grey-13--text">{{ scheduleDateText }}<v-icon small class="ml-6">mdi-check</v-icon></span>
                                    </v-btn>
                                </v-fade-transition>
                            </v-layout>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </v-card>

    <!-- <v-card outlined rounded="xl">
        <v-row justify="start" align="center" class="mx-0 ">
            <v-col cols="12" md="auto" class="px-28 px-lg-58 py-24">
                <v-img class="mx-auto" width="166" height="36" :src="value?.company?.logo?.url">
                    <v-fade-transition>
                        <v-overlay v-show="!value?.company?.logo?.url" absolute light color="white">
                            <v-layout row align-center class="black--text">
                                <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                <span> {{ value?.company?.name }} </span>
                            </v-layout>
                        </v-overlay>
                    </v-fade-transition>
                </v-img>
            </v-col>
            <v-col cols="auto">
                <v-card-subtitle class="pt-24 pb-0 primary--text page-text--sm">{{ value?.company?.name }}</v-card-subtitle>
                <v-card-title class="pt-0 page-text--lg">{{ value?.title }}</v-card-title>
                <v-card-subtitle class="pb-0 page-text grey-6--text ellip d-flex align-center">
                    매칭URL: {{ matchUrl }}
                    <v-btn text icon :href="matchUrl"> <v-icon>mdi-link</v-icon> </v-btn>
                    <meeting-view v-bind="{ value }" @input="(value) => $emit('input', value)">
                        <template #activator="{ attrs, on }">
                            <v-btn text icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-open-in-new</v-icon>
                            </v-btn>
                        </template>
                    </meeting-view>
                </v-card-subtitle>
                <v-card-text class="pb-24 page-text--sm page-text page-text--sm grey-9--text line-height-15 ">
                    <meeting-list-item-matching v-bind="{ value }" />
                </v-card-text>
            </v-col>
            <v-col cols="auto" class="mr-auto px-24">
                <v-sheet style="position: relative" min-width="140">
                    <v-card-subtitle class="pa-0 page-text--sm">상태</v-card-subtitle>
                    <v-card-title class="pa-0 pt-8 page-text--lg"><i class="icon icon-dot icon-dot--primary mr-4" />{{ stateText }}</v-card-title>
                    <v-fade-transition>
                        <v-overlay v-show="loading" absolute light color="white">
                            <v-progress-circular size="40" width="2" indeterminate color="primary" />
                        </v-overlay>
                    </v-fade-transition>
                </v-sheet>
            </v-col>
            <v-col cols="auto" class="pa-24">
                <v-fade-transition leave-absolute>
                    <v-btn color="primary" v-show="!showsScheduleDate" outlined right @click="showsScheduleDate = true">미팅 일정 확인</v-btn>
                </v-fade-transition>
                <v-fade-transition leave-absolute>
                    <v-btn v-show="showsScheduleDate" color="grey lighten-2" @click="showsScheduleDate = false">{{ scheduleDateText }} <v-icon small class="ml-10">mdi-check</v-icon> </v-btn>
                </v-fade-transition>
            </v-col>
        </v-row>
    </v-card> -->
</template>

<script>
import api from "@/api";
import { initMeetingSchedule, MEETING_SCHEDULE_STATES } from "@/assets/variables";
import ImageOverlay from "@/components/dumb/image-overlay.vue";

import MeetingView from "../view/meeting-view.vue";
import MeetingListItemMatching from "@/components/dashboard/company/meeting/list/meeting-list-item-matching.vue";
import dayjs from "dayjs";

export default {
    components: {
        MeetingView,
        MeetingListItemMatching,
        ImageOverlay,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // meeting
    },
    data: () => ({
        schedule: initMeetingSchedule(),

        loading: false,
        showsScheduleDate: false,
    }),
    computed: {
        matchUrl() {
            return `${window.location.origin}/meetings/${this.value?._id}`;
        },
        stateText() {
            if (this.schedule?.state == MEETING_SCHEDULE_STATES.CANCELED.value) return "미팅 취소";
            if (this.schedule?.state == MEETING_SCHEDULE_STATES.APPROVED.value) return "미팅 확정";
            if (this.schedule?.date) return "일정 선택 완료";
            else return "일정 선택 전";
        },
        stateColor() {
            if (this.schedule?.state == MEETING_SCHEDULE_STATES.CANCELED.value) return "grey";
            if (this.schedule?.state == MEETING_SCHEDULE_STATES.APPROVED.value) return "primary";
            if (this.schedule?.date) return "secondary";
            else return "green";
        },
        scheduleDateText() {
            if (!this.schedule?.date) return "선택한 일정이 없습니다";
            else return dayjs(this.schedule?.date).format("YY년 MM월 DD일 a hh:mm");
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
    },
    methods: {
        copy(string) {
            navigator.clipboard.writeText(string);
        },

        async init() {
            if (this.loading) return;
            this.loading = true;
            try {
                if (this.value?._id) this.schedule = (await api.v1.person.meetings.schedule.get({ _meeting: this.value?._id }))?.schedule || initMeetingSchedule();
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.applied-card__link {
    max-width: calc(100% - 64px);
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .applied-card__detail {
        width: 520px;
    }
}
@media (min-width: 1024px) {
    .applied-card__link {
        max-width: calc(100% - 92px);
    }
}
@media (min-width: 1200px) {
}
</style>
